import { render, staticRenderFns } from "./LoginLogExtends.vue?vue&type=template&id=aa4d7c0c&"
import script from "./LoginLogExtends.vue?vue&type=script&lang=js&"
export * from "./LoginLogExtends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoginLogExtends.vue"
export default component.exports